import http from '@/utils/network/http/axios'
const { REFRESH_TOKEN, MANAGE, COMMON, READ } = process.env
import config from '@/config'

/**
 * 刷新token
 * @param {*}
 */
export function refreshToken() {
  return http.post(`${REFRESH_TOKEN}/oauth/token`)
}
/**
 * 账号密码登录
 * @param {*}
 */
export function doLogin(params) {
  return http.post(`/login/doLogin`, params)
}
/**
 * 机构名登录
 * @param {*}
 */
 export function pxjgLogin(params) {
  return http.post(`/login/pxjgLogin`, params)
}

/**
 * 获取省市区列表
 * @param {*}
 */
 export function getAreaList(params) {
  return http.post(`/common/getAreaList`, params)
}


/**
 * 上传头像
 * @param {*}
 */
export function uploadSFFilen(params) {
  return http.post(`/common/uploadSFFilen`, params)
}
/**
 * 身份证上传
 * @param {*}
 */
 export function fileUpsfz_byother1(params) {
  return http.post(`/common/fileUpsfz_byother1`, params)
}
/**
 * 上传base64图片
 * @param {*}
 */
 export function fileUpbyBase64(params) {
  return http.post(`/common/fileUpbyBase64`, params)
}

/**
 * 身份证读卡保存用户信息
 * @param {*}
 */
 export function readCardadduse(params) {
  return http.post(`/user/readCardadduse`, params)
}

/**
 * 获取所有地址
 * @param {*}
 */
export function getAllLocation() {
  return http.post(`${COMMON}/area/getAllLocation`)
}

/**
 * 获取所有地址
 * @param {*}
 */
 export function cxoCallback() {
  return http.post(`/common/cxoCallback`)
}

/**
 * 获取工种与行业列表
 * @param {*}
 */
 export function getKcformSel() {
  return http.post(`/common/getKcformSel`)
}

/**
 * 获取工种与行业列表
 * @param {*}
 */
 export function downStudentsfzZiper() {
  return config.connectPath + '/online-training/common/export/downStudentsfzZiper'
  // return http.post(`/common/export/downStudentsfzZiper`)
}

/**
 * 报名打印预览
 * @param {*}
 */
 export function bmlist_print_more(params) {
  return http.post(`/bm/common/bmlist_print_more`, params)
}

/**
 * 获取过去六年年份
 * @param {*}
 */
 export function getHisYearList(params) {
  return http.post(`/common/getHisYearList`, params)
}

//获取内网地址
export function getNativeUrl(params) {
  return http.post(`/common/getNativeUrl`, params)
}